import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DynamicRule } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { Shop } from '@services/shops/shop.model';
import { Observable } from 'rxjs';
import {
  TRUST_SIGNAL_ICON_OPTIONS,
  TRUST_SIGNALS_BACKGROUND_OPTIONS,
  TRUST_SIGNALS_BORDER_OPTIONS,
  TRUST_SIGNALS_CORNER_OPTIONS,
  TRUST_SIGNALS_LAYOUT_OPTIONS,
} from '@app/pages/checkout-app/checkout-layout/main/components/extensions/components/extension-components/custom-upsell/model';

@Component({
  selector: 'custom-upsell-form-settings',
  templateUrl: './custom-upsell-form-settings.component.html',
  styleUrl: './custom-upsell-form-settings.component.scss',
  standalone: false,
})
export class CustomUpsellFormSettingsComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() restrictionsRules: DynamicRule[];
  @Input() entities: any[];
  @Input() shopCurrencySymbol: string;
  @Input() shop$: Observable<Shop>;
  @Input() shopService: any;
  @Input() loadedExtension: any;
  @Input() updateRequired: boolean;
  @Input() updateAppUrl: string;
  @Input() productImageBase64: string;
  @Input() customUpsellConfig: any[];
  @Input() upsellRateTypeConfig: any[];
  @Input() applyDiscountToOptions: any[];
  @Input() PlacementMode: any;
  @Input() camelCaseToTitleCase: (str: string) => string;
  @Input() formArrayFieldName: string;
  @Output() applyDiscountToChange = new EventEmitter<any>();
  @Output() productImageChange = new EventEmitter<string>();
  @Output() clearImageEvent = new EventEmitter<void>();
  @Output() updateAppPermissions = new EventEmitter<void>();

  trustSignalIconKeys = TRUST_SIGNAL_ICON_OPTIONS.map((option) => option.value);
  trustSignalIconLabels = TRUST_SIGNAL_ICON_OPTIONS.map((option) => option.label);
  trustSignalsLayoutOptions = TRUST_SIGNALS_LAYOUT_OPTIONS;
  trustSignalsBackgroundOptions = TRUST_SIGNALS_BACKGROUND_OPTIONS;
  trustSignalsBorderOptions = TRUST_SIGNALS_BORDER_OPTIONS;
  trustSignalsCornerOptions = TRUST_SIGNALS_CORNER_OPTIONS;

  constructor(private formBuilder: UntypedFormBuilder) {}

  onApplyDiscountToChange(event: any) {
    this.applyDiscountToChange.emit(event);
  }

  addTrustSignal() {
    this.trustSignalItems.push(this.formBuilder.group({ icon: [''], richText: [''] }));
    this.trustSignalItems.markAsDirty();
  }

  removeTrustSignal(index: number) {
    this.trustSignalItems.removeAt(index);
    this.trustSignalItems.markAsDirty();
  }

  onTrustSignalIconChange(index: number, icon: string | File) {
    const control = this.trustSignalItems.at(index)?.get('icon');
    control?.setValue(typeof icon === 'string' ? icon : '');
    control?.markAsDirty();
  }

  onInfoPopupImageChange(base64Image: string) {
    this.formGroup.get('infoPopupImage')?.setValue(base64Image ?? '');
    this.formGroup.get('infoPopupImage')?.markAsDirty();
  }

  onClearInfoPopupImage() {
    this.formGroup.get('infoPopupImage')?.setValue('');
  }

  get trustSignalItems(): UntypedFormArray {
    return this.formGroup.get('trustSignals.items') as UntypedFormArray;
  }

  onProductImageChange(base64Image: string) {
    this.productImageChange.emit(base64Image);
  }

  onClearImage() {
    this.clearImageEvent.emit();
  }

  onUpdateAppPermissionsClick() {
    this.updateAppPermissions.emit();
  }
}
